export const EXPENSES = 'expenses';
export const COLLECTIONS = 'collections';
export const PAYMENTS = 'payments';
export const RETURNS = 'returns';

export const CLIENT_PAYMENTS_OPERATIONS = [
  {
    label: <span data-testid="expense-operation">Расходы</span>,
    value: EXPENSES,
    filterName: 'Расходы',
  },
  {
    label: <span data-testid="cash-collection-operation">Инкассации</span>,
    value: COLLECTIONS,
    filterName: 'Инкассации',
  },
  {
    label: <span data-testid="income-operation">Поступления</span>,
    value: PAYMENTS,
    filterName: 'Поступления',
  },
  {
    label: (
      <span data-testid="cash-replenishment-operation">Пополнение кассы</span>
    ),
    value: 'register-payment',
    filterName: 'Пополнение кассы',
  },
  {
    label: <span data-testid="refund-operation">Возвраты</span>,
    value: RETURNS,
    filterName: 'Возвраты',
  },
];
